<form [formGroup]="form" class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.addClass.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.addClass.requiredHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('manageEvent.addClass.className' | translate) + ' *'"
          [placeholder]="'manageEvent.addClass.classNamePlaceholder' | translate"
          [type]="'text'"
          [value]="v('class_name')"
          (valueChange)="set('class_name', $event)"
          [invalid]="(form.get('class_name')?.invalid && form.get('class_name')?.touched) || false"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-selectorini
          [label]="'manageEvent.addClass.classType' | translate"
          [options]="classTypes"
          [displayKey]="'class_name'"
          (valueChange)="set('parent_class_id', $event || null)"
        />
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'manageEvent.addClass.description' | translate"
          [placeholder]="'manageEvent.addClass.descriptionPlaceholder' | translate"
          [type]="'text'"
          [value]="v('class_description')"
          (valueChange)="set('class_description', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('manageEvent.addClass.startDateTime' | translate) + ' *'"
          [placeholder]="'YYYY-MM-DDTHH:mm'"
          [type]="'datetime-local'"
          [value]="v('start_date_time')"
          (valueChange)="set('start_date_time', $event)"
          [invalid]="(form.get('start_date_time')?.invalid && form.get('start_date_time')?.touched) || false"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.addClass.maxRegistrations' | translate"
          [placeholder]="'manageEvent.addClass.maxRegistrationsPlaceholder' | translate"
          [type]="'number'"
          [value]="v('max_num_registrations')"
          (valueChange)="set('max_num_registrations', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [label]="'manageEvent.addClass.requiredHorseRegistries' | translate"
          [options]="horseRegistries"
          [displayKey]="'registry_name'"
          [valueKey]="'registry_id'"
          [bindValue]="false"
          [multiple]="true"
          [value]="v('req_horse_registries')"
          (valueChange)="set('req_horse_registries', $event || [])"
        />
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.addClass.maxParticipantAge' | translate"
          [placeholder]="'manageEvent.addClass.maxAgePlaceholder' | translate"
          [type]="'number'"
          [value]="v('max_participant_age')"
          (valueChange)="set('max_participant_age', $event)"
        ></app-input-component>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.addClass.minHorseAge' | translate"
          [placeholder]="'manageEvent.addClass.minAgePlaceholder' | translate"
          [type]="'number'"
          [value]="v('min_horse_age')"
          (valueChange)="set('min_horse_age', $event)"
        ></app-input-component>
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.addClass.secondsPerParticipant' | translate"
          [placeholder]="'manageEvent.addClass.secondsPlaceholder' | translate"
          [type]="'number'"
          [value]="v('time_per_participant_seconds')"
          (valueChange)="set('time_per_participant_seconds', $event)"
        ></app-input-component>
      </div>
    </div>

    <!-- Pricing Section -->
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="isFreeClass"
            [checked]="isFree"
            (change)="toggleFree($any($event.target).checked)"
          >
          <label class="form-check-label" for="isFreeClass">
            {{ 'manageEvent.addClass.freeClass' | translate }}
          </label>
          <div class="form-text text-muted">{{ 'manageEvent.addClass.freeClassHint' | translate }}</div>
        </div>
      </div>
    </div>

    @if (!isFree) {
      <div class="row g-4 spacing-15">
        <div class="col-lg-4 col-12">
          <app-input-component
            [label]="'manageEvent.addClass.price' | translate"
            [placeholder]="'manageEvent.addClass.pricePlaceholder' | translate"
            [type]="'number'"
            [value]="v('price')"
            (valueChange)="set('price', $event)"
          ></app-input-component>
          @if (v('price') > 0) {
            <div class="text-muted small mt-1">
              {{ 'common.netAmountHint' | translate:{ amount: calculateNetAmount(v('price')), currency: v('price_currency') || 'NOK' } }}
            </div>
          }
        </div>

        <div class="col-lg-4 col-12">
          <app-selectorini
            [label]="'manageEvent.addClass.currency' | translate"
            [options]="currencyOptions"
            [displayKey]="'name'"
            [valueKey]="'code'"
            [value]="v('price_currency')"
            [disabled]="true"
          />
        </div>

        <div class="col-lg-4 col-12">
          <app-selectorini
            [label]="'manageEvent.addClass.vat' | translate"
            [options]="vatRateOptions"
            [displayKey]="'label'"
            [valueKey]="'value'"
            [value]="v('vat_rate') || 0"
            (valueChange)="set('vat_rate', $event)"
          />
        </div>
      </div>
    }

    <!-- Membership plan ids -->
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-selectorini
          [label]="'manageEvent.addClass.requiredMemberships' | translate"
          [options]="membershipPlans"
          [displayKey]="'name'"
          [valueKey]="'plan_id'"
          [bindValue]="false"
          [multiple]="true"
          [value]="v('req_membership_plans')"
          (valueChange)="set('req_membership_plans', $event || [])"
        />
      </div>
    </div>

    <!-- Scoring Configuration Section -->
    <div class="row g-4 spacing-30">
      <div class="col-12">
        <h4 class="mb-3">{{ 'scoring.configureScoring' | translate }}</h4>
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [label]="'scoring.scoreType' | translate"
          [options]="scoreTypeOptions"
          [displayKey]="'label'"
          [valueKey]="'value'"
          [value]="v('score_type')"
          (valueChange)="set('score_type', $event)"
        />
      </div>

      <div class="col-lg-6 col-12 d-flex align-items-center">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="createRound"
            [checked]="v('create_round')"
            (change)="set('create_round', $any($event.target).checked)"
          >
          <label class="form-check-label" for="createRound">
            {{ 'rounds.createDefaultRound' | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- Sponsors Section -->
    <div class="row g-4 spacing-30">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="mb-0">{{ 'manageEvent.addClass.sponsors' | translate }}</h4>
          <app-button
            [label]="'manageEvent.addClass.createSponsor' | translate"
            [variant]="'primary'"
            [iconClass]="'fa fa-plus-circle'"
            (clicked)="openCreateSponsorModal()"
          ></app-button>
        </div>

        @if (selectedSponsors.length > 0) {
          <div class="row g-3">
            @for (sponsor of selectedSponsors; track sponsor.sponsor_id) {
              <div class="col-lg-6 col-12">
                <div class="card h-100">
                  <div class="card-body">
                    <div class="d-flex gap-3">
                      <div class="flex-shrink-0">
                        @if (sponsor.logo_url) {
                          <img [src]="sponsor.logo_url" alt="{{ sponsor.sponsor_name }}" class="sponsor-logo" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px;">
                        } @else {
                          <div class="sponsor-placeholder d-flex align-items-center justify-content-center" style="width: 80px; height: 80px; background-color: #f0f0f0; border-radius: 8px;">
                            <i class="fa fa-image text-muted" style="font-size: 2rem;"></i>
                          </div>
                        }
                      </div>
                      <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <h5 class="mb-0">{{ sponsor.sponsor_name }}</h5>
                          <button
                            type="button"
                            class="btn-close"
                            (click)="removeSponsor(sponsor)"
                            [attr.aria-label]="'manageEvent.addClass.removeSponsor' | translate"
                          ></button>
                        </div>
                        <p class="text-muted small mb-0">{{ sponsor.sponsor_description || ('manageEvent.addClass.noDescription' | translate) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="text-center py-4 border rounded bg-light">
            <i class="fa fa-handshake-o text-muted mb-2" style="font-size: 2.5rem;"></i>
            <p class="text-muted mb-0">{{ 'manageEvent.addClass.noSponsors' | translate }}</p>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <app-button
      [label]="saving ? ('common.saving' | translate) : ('common.save' | translate)"
      [variant]="'primary'"
      [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
      [disabled]="saving"
      (clicked)="save()"
    ></app-button>
  </div>
</form>
